//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import titles from "@/components/common-titles";
import commonIndustry from "@/components/common-industry2";

import {
  updateUserIndustry,
  appuserInfo,
  closeIndustryTips,
  selectDindustryListByTitle,
  titleRecommend, //课程列表查询接口
  selectClassLibraryIsVisible,
  addShopping
} from "@/assets/js/api";
export default {
  name: "settitle",
  components: { titles ,commonIndustry},
  props:["showSetTitle"],
  data() {
    return {
      isquick:0,
      isNotFoundMajor:0,
      customIndustry:"",//自定义专业
      hasChangeFtitle:false,
      industryNum1:null,
      industryNum2:null,
      majorlist:[],
      industryShow:false,
      titlesIsShow:false,
      industry2:"",
      titlesId:null,
      ruleFormTitle:{
        ftitleName:"",
        stitleName:"",
        titlefName:"",
        titlef:"",

        titleList:[],
        industryId: null, //行业第一职称
        sindustryId: null, //行业第二职称
        firjob: "", // 职称
        industryNames: "", //行业的名字
        industryId:null, //行业1级id
        sindustryId:null, //行业2级id
        tindustryId:null, //行业3级id
      },
      showDialogTitle: true,
      searchFalse: true,
      classType: this.$route.query.classType ? this.$route.query.classType : 0, //tab默认第一个
      course: [], // 获取到的精品课列表数据,
      pageSize: 20, // 每次加载数据条数
      pageNum: 1, // 页数
      total: 0, // 总条数
      loading: false, // 加载数据
      courseValue: "", // 搜索input框的值
      index: 0,
      blankRecommend:0,
      sindustryStatus:0,
      searchData: [], //职称、标签、课时、价格搜索集合
      navArrsearchType: "专业课", //搜索类型
      searchStatus: false,
      navArr: [
        //导航数组
        {
          type: 0,
          name: "专业课"
        },
        {
          type: 1,
          name: "公需课"
        },
        {
          type: 2,
          name: "考前辅导课"
        }
      ],
      isshow: false,
      showType: false,
      isAdd: false,
      isAddShop: false,
      height: ""
    };
  },
  created() {
    if(window.localStorage.getItem("token")){
      this.getUserInfo()
    }
    
    
  },
  mounted() {

  },
  watch: {
    height: {
      handler: function(val, oldVal) {
        window.onresize = () => {
          this.$zj.setTopFn("footer");
        };
      },
      // 深度观察监听
      deep: true
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/courseDetails" || from.path == "/fkxx") {
      to.meta.keepAlive = true;
    } else {
      to.meta.keepAlive = false;
    }
    next();
  },
  // activated() {
  //   if (!this.$route.meta.isBack) {
  //     console.log('从其他页面进入精品课')
  //     //  this.handleClear('queryForm');/*清空查询条件*/
  //   }else{
  //     console.log('从详情进入精品课')
  //     // this.$route.meta.isBack = false;
  //     // this.getBorrowList();/*列表重新加载*/
  //   }
  // },
  methods: {
    setTitle(n){
      if(n==1){
        this.isquick=1
      }
      this.showSetTitle = true;

    },
    saveTitleIndustry(){
      if(this.ruleFormTitle.titlef && this.ruleFormTitle.industryId && this.ruleFormTitle.sindustryId   || (!this.ruleFormTitle.sindustryId && this.customIndustry)){
        updateUserIndustry({
          "data":{
            "titlef":this.ruleFormTitle.titlef,
            "industryId": this.ruleFormTitle.industryId,
            "sindustryId":this.ruleFormTitle.sindustryId,
            engageMajor:this.customIndustry,
            isNotFoundMajor:this.ruleFormTitle.sindustryId==0?1:0
          }
        }).then(res=>{
          if(res.message.errcode==200){
            this.$zj.alert({
              TITLE:"提示",
              CONTENT:"修改成功"
            })
            this.closeShowDialogTitle();
            this.getUserInfo();
            // if(this.$store.state.showDialogTitle){
              // this.$store.state.showDialogTitle=false;
              this.$store.state.showGGTitle=false;
              // debugger
              let userInfo =JSON.parse(window.localStorage.getItem("userInfo"));
              userInfo.sindustryId=this.ruleFormTitle.sindustryId;
              console.log(userInfo)
              window.localStorage.setItem('userInfo',JSON.stringify(userInfo));
            // }else{
              this.queryCourse(2)
            // }   
          }
        })
      }else{
        this.$zj.alert({
          TITLE:"提示",
          CONTENT:"请先选择职称和专业！"
        })
      }
      
    },
    queryCourse(){
      this.$emit("queryCourse",this.industry2)
    },
    industryBackFn(item) {
        // this.industry1 = it;
        this.ruleFormTitle.industryId = item.parentCode;
        this.ruleFormTitle.sindustryId = item.id;
        this.industry2 = item.industryName;
        this.industryNum1 = item.parentCode;
        this.industryNum2 = item.id;
        if(item.id=="0"){
          this.isNotFoundMajor = 1
        }else{
          this.isNotFoundMajor = 0
        }
        // this.dataJson.industry2 = item.industryName;
        this.industrycloseFn();
      
    },
    closeShowDialogTitle(){
      // showSetTitle = false;
      this.$emit("close")

    },
    ignoreTitle(){
      //忽略修改 不再提醒
      closeIndustryTips({}).then(res=>{
        if(res.message.errcode == 200){
          this.sindustryStatus = 0;
        }
      })
    },
        //获取职称对应专业
    getIndustrys(){
      this.titleindustry = null;
      if(this.titlefFid){
        // 获取专业接口
        selectDindustryListByTitle({
          data:{
              ftitleId:this.titlefFid
          }
        }).then(res=>{
          if(res.message.errcode == 200){
            this.majorlist = res.data;
            this.majorlist.push({industryName: "未找到我的专业",parentCode:this.majorlist[0].parentCode, id: '0'})
          }
        })
      }
    },

    getUserInfo(){      
      appuserInfo({}).then(res => {
        if (res.message.errcode == 200) {
          // debugger
          let firjob = [];
          this.isNotFoundMajor = res.data.user.isNotFoundMajor;
          this.titlefFid = res.data.user.titlefFid
          if(res.data.user.titlefFid){
            this.getIndustrys();
          }
          if (!res.data.user.ftitleName || res.data.user.ftitleName == "未选择") {
            firjob = [];
          } else if (!res.data.user.titlef || res.data.user.ftitleName == "未选择") {
            //防止老数据职称不对造成无法保存做特殊处理
            firjob = [];
          } else {
            firjob = [];
            if (res.data.titlefName && res.data.user.ftitleName != "未选择") {
              firjob = [
                res.data.user.ftitleName,
                res.data.user.stitleName,
                res.data.titlefName,
              ];
               
              this.$emit("getTitle",{
                title1:res.data.user.ftitleName,
                title2:res.data.user.stitleName,
                title3:res.data.titlefName,
                industry2name:res.data.sindustryName || res.data.user.engageMajor,

              })
            } else if (res.data.user.stitleName && res.data.user.ftitleName != "未选择") {
              firjob = [res.data.user.ftitleName, res.data.user.stitleName];
            } else if (res.data.user.ftitleName && res.data.user.ftitleName != "未选择") {
              firjob = [res.data.user.ftitleName];
            }
          }
          //行业
          let industryNames = [];
          if (res.data.tindustryName) {
            industryNames = [
              res.data.industryName,
              res.data.sindustryName,
              res.data.tindustryName,
            ];
          } else if (res.data.sindustryName) {
            this.titleindustry = res.data.user.sindustryId;
            // this.getIndustrys();
            industryNames = [res.data.industryName, res.data.sindustryName];
          } else if (res.data.industryName) {
            industryNames = [res.data.industryName];
          }
          res.data.user.sindustryId==0 && res.data.user.isNotFoundMajor==1?this.industryNum2 = "0":this.industryNum2 = res.data.user.sindustryId
          this.industryNum2 == 0  && res.data.user.isNotFoundMajor==1 ? this.industry2 = "未找到我的专业": res.data.sindustryName?this.industry2 = res.data.sindustryName:"";
          
          res.data.user.engageMajor?this.customIndustry = res.data.user.engageMajor:''
          
          this.$emit("getSindustry",res.data.user.sindustryId)
          this.ruleFormTitle = {
            ftitleName:res.data.user.ftitleName,
            stitleName:res.data.user.stitleName,
            titlefName:res.data.titlefName,
            titlef: res.data.user.titlef,
            titleList:this.ruleFormTitle.titleList,
            titlefNameID: res.data.user.ftitleName != "未选择" ? res.data.user.titlef : null, //第一职称的第三职称ID
            titlefNameID1: res.data.user.ftitlesName != "未选择" ? res.data.user.titles : null, //第二职称的第三职称ID
            firjob: firjob.join("/"), // 职称
            industryNames: industryNames.join("/"), //行业的名字
             industryId:
              res.data.user.industryId == 0 ? null : res.data.user.industryId, //行业1级id
            sindustryId:
              res.data.user.sindustryId == 0 ? null : res.data.user.sindustryId, //行业2级id
            tindustryId:
              res.data.user.tindustryId == 0 ? null : res.data.user.tindustryId, //行业3级id
          }
          
        }
      })

    },
    getmajorlist(){
      selectDindustryListByTitle({data:{
        "ftitleId":this.fTitle
      }}).then(res=>{
        if(res.message.errcode ==  200){
          this.majorlist = res.data;
          this.majorlist.push({industryName: "未找到我的专业",parentCode:this.majorlist[0].parentCode, id: '0'})
        }
      })
    },


    showIndustryMask() {
      this.industryShow = true;
    },

    queryTitle(num) {
      //num 1 第一职称 2 第二职称
      window.localStorage.setItem("ruleFormTitle", JSON.stringify(this.ruleFormTitle));
      this.titlesIsShow = true;
      this.titleNum = num;
      this.titlesId = this.ruleFormTitle.titlef;

    },
        //职称的选择
    titlesBackFn(level, id, name) {
      var firjob = [];
        if (level == 0) {
          this.ruleFormTitle.ftitleName = name;
          this.ruleFormTitle.stitleName = "";
          this.ruleFormTitle.titlefName = "";
          this.ruleFormTitle.titlef = "";
          this.fTitle = id;
            this.hasChangeFtitle = true;

          firjob = [this.ruleFormTitle.ftitleName];
        } else if (level == 1) {
          this.ruleFormTitle.stitleName = name;
          firjob = [this.ruleFormTitle.ftitleName, this.ruleFormTitle.stitleName];
        } else if (level == 2) {
          this.ruleFormTitle.titlefName = name;
          this.ruleFormTitle.titlef = id;
          this.titlesIsShow = false;
          firjob = [
            this.ruleFormTitle.ftitleName,
            this.ruleFormTitle.stitleName,
            this.ruleFormTitle.titlefName,
          ];
          if(this.hasChangeFtitle == true){
            this.industry2=""
            this.industryNum2 = null
            this.getmajorlist();
            this.hasChangeFtitle = false;
            this.isNotFoundMajor = 0;
          }
          this.ruleFormTitle.firjob = firjob.join("/")
        }
        
        
          

    },
    closeFn() {
      this.ruleFormTitle = JSON.parse(window.localStorage.getItem("ruleFormTitle"));
      this.titlesIsShow = false;
      this.hasChangeFtitle = false;

    },
    industrycloseFn() {
      this.industryShow = false;
    },


  }
};



// WEBPACK FOOTER //
// ./src/views/course/settitle.vue